import React from "react";
import { useLocation } from "react-router-dom";
import { cn } from "../../utils/cn";
import Icon from "../AppIcon";

const AdminHeader = ({ onMenuClick, onToggleSidebar, sidebarOpen, menuItems }) => {
  const location = useLocation();

  const currentLabel =
    menuItems?.find((item) => location.pathname === item.path || location.pathname.startsWith(item.path + "/"))
      ?.label || "Dashboard";
  const isNestedSettings =
    location.pathname.startsWith("/admin/settings/") && location.pathname !== "/admin/settings";

  return (
    <header className="bg-card border-b border-border shadow-sm sticky top-0 z-30 px-4 sm:px-6 py-3 sm:py-4">
      <div className="flex items-center justify-between gap-2 sm:gap-4">
        <div className="flex items-center gap-2 sm:gap-4 flex-1 min-w-0">
          <button
            type="button"
            onClick={onMenuClick}
            className="lg:hidden w-9 h-9 rounded-lg bg-primary text-primary-foreground flex items-center justify-center shadow-md hover:opacity-90 transition-opacity flex-shrink-0"
            aria-label="Open menu"
          >
            <Icon name="Menu" size={18} />
          </button>
          <div className="min-w-0 flex-1">
            <h2 className="text-lg sm:text-xl font-bold text-text-primary truncate">
              {currentLabel}
            </h2>
            <p className="text-xs sm:text-sm text-text-secondary hidden sm:block">
              {isNestedSettings ? "Manage roles and permissions" : "Manage your platform"}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
          <div className="relative p-2 sm:p-2.5 rounded-lg hover:bg-muted transition-colors cursor-pointer">
            <Icon
              name="Bell"
              size={18}
              className="sm:w-5 sm:h-5 text-text-secondary hover:text-text-primary"
            />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 sm:w-2.5 sm:h-2.5 bg-error rounded-full border-2 border-card" />
          </div>
          <div className="w-8 h-8 rounded-full bg-muted flex items-center justify-center flex-shrink-0">
            <Icon name="User" size={16} className="text-text-secondary" />
          </div>
          <button
            type="button"
            onClick={onToggleSidebar}
            className="hidden lg:flex w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-primary text-primary-foreground items-center justify-center shadow-md hover:opacity-90 transition-opacity"
            aria-label={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
          >
            <Icon name={sidebarOpen ? "ChevronLeft" : "ChevronRight"} size={18} />
          </button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
